//import Color from "color"; //https://github.com/Qix-/color

//great app to mix colors: https://colordesigner.io/color-mixer
//http://colormind.io/bootstrap/
export const MYCOLORS = {
  lback: "#F3F6F6", //the paper
  lpaper: "#2F4D70", //cards such as testimonials
  lcard: "#F3F6F6", //testi card
  ldeck: "#F3F6F6",//"#937970", // animated deck
  lhighlight: "#17a2b8", //buttons etc
  lphucircle: "#17a2b8",//"#929295",//"transparent",
  ltitletext: "#2F4D70", //inclluding testimonial text
  lthumb: "#d4eaed", //lighten/whiten version of highlight color
  lthumbhover: "#17a2b8", //more highlight color than lthumb

  dback: "#15202B",
  dpaper: "#192734",
  dcard: "#15202B",//"#142532",
  ddeck: "#2F4D70",//"#b1782f",
  dhighlight: "#FFA431",
  dphucircle: "#2F4D70", //"transparent",//"#d98f32",
  dtitletext: "#FFA431",
  dthumb: "#212e3b", //"#303434",
  dthumbhover: "#FFA431",
};
